import { createContext } from "react";

export const gridContext = createContext();
